import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import authService from '../../../services/authService';

const AdminProtectedRoute = () => {
  const token = authService.getAdminToken();
  
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;